import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import { Icon, TextField, Button } from '@material-ui/core';

const styles = theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
});

class FullWidthTabs extends React.Component {
    state = {
        value: 0,
    };

    handleChange = (event, value) => {
        this.setState({ value });
    };

    handleChangeIndex = index => {
        this.setState({ value: index });
    };

    render() {
        const searchBar =
            <TextField
                id="search"
                label={<Icon>search</Icon>}
                className={this.props.classes.textFieldSearch}
                value={this.state.rightSearch}
                onChange={(e) => this.props.handleSearchChange(e)}
                margin="normal"
                disabled={this.props.view_type === 'detail'}
            />

        const { theme } = this.props;
        const takenIds = [];

        const mappedLeftTabData = this.props.currentRelationsTabData.map(i => {
            takenIds.push(i.id)
            return <div className="currentItemWrapper" key={i.id}>
                <SnackbarContent className="AlreadySelected" message={i.label}
                    action={
                        <Button color="secondary" size="small" onClick={() => (this.props.handleDelete(i, 'REMOVE'))}>
                            DROP
                        </Button>}
                />
            </div>
        });

        const filteredSearch = this.props.availableObjectList
            .filter(item => !this.props.search || item.label.toLowerCase().includes(this.props.search.toLowerCase()))
            .map((item, index) => {
                if (!takenIds.includes(item.id)) {
                    return (

                        <div className="currentItemWrapper" key={item.id}>
                            <SnackbarContent message={item.label}
                                action={
                                    <Button color="secondary" size="small" onClick={() => this.props.handleAdd(item, 'ADD')}>
                                        ADD
                                    </Button>
                                }
                            />
                        </div>
                    )
                }
                else {
                    return (
                        <div key={item.id}>
                            <SnackbarContent className="AlreadySelected" message={item.label}
                                action={
                                    <Button className="RightTabDelete" color="secondary" size="small" onClick={() => (this.props.handleDelete(item, 'REMOVE'))}>
                                        DROP
                                    </Button>
                                }
                            />
                        </div>
                    )
                }
            })

        return (
            <div className={this.props.rootClass}>
                <AppBar position="static" color="default">
                    <Tabs
                        value={this.state.value}
                        onChange={this.handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        fullWidth
                    >
                        <Tab label={this.props.leftHeader} />
                        <Tab label={this.props.rightHeader} />
                    </Tabs>
                </AppBar>

                <SwipeableViews
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={this.state.value}
                    onChangeIndex={this.handleChangeIndex}
                >
                    <Typography component="div" dir={this.props.dir} style={{ padding: 8 * 3 }}>
                        {mappedLeftTabData}
                    </Typography>
                    <Typography component="div" dir={this.props.dir} style={{ padding: 8 * 3 }}>
                        {searchBar}
                        {filteredSearch}
                    </Typography>
                </SwipeableViews>
            </div>

        );
    }
}

FullWidthTabs.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(FullWidthTabs);


// WEBPACK FOOTER //
// src/main/components/RelationUpdateTabs.js